import { render } from "./waNotifModal.vue?vue&type=template&id=8527b5cc&scoped=true"
import script from "./waNotifModal.vue?vue&type=script&lang=js"
export * from "./waNotifModal.vue?vue&type=script&lang=js"

import "./waNotifModal.vue?vue&type=style&index=0&id=8527b5cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8527b5cc"]])

export default __exports__